import React from 'react';
import styled from 'styled-components';
import { Box } from 'src/kit/Box';
import { Flex } from 'src/kit/Flex';
import { LogoTiny } from 'src/components/Logo';

const FooterLink = styled.a`
  color: #8a99a8;
  font-size: 0.88rem;
  text-decoration: none;
  display: block;
  margin-bottom: 12px;
  transition: color 0.2s;

  &:hover {
    color: white;
  }
`;

const EmployerFooter = () => {
  return (
    <Box
      as="footer"
      style={{ background: '#0D1B2A', padding: '100px 5% 60px', borderTop: '1px solid rgba(255,255,255,0.05)' }}
    >
      <Box style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Box
          style={{
            display: 'grid',
            gridTemplateColumns: '2fr 1fr 1fr 1fr',
            gap: '60px',
            marginBottom: '80px'
          }}
          css={`
            @media (max-width: 768px) {
              grid-template-columns: 1fr !important;
              gap: 40px !important;
            }
          `}
        >
          <Box>
            <LogoTiny color="#2dbd96" height={28} mb="20px" />
            <Box
              style={{
                color: 'white',
                fontWeight: 700,
                fontSize: '1.2rem',
                marginBottom: '20px',
                fontFamily: "'DM Sans', sans-serif"
              }}
            >
              Sainoo{' '}
              <Box as="span" style={{ color: '#2dbd96' }}>
                ·
              </Box>{' '}
              Calmon Partners
            </Box>
            <Box style={{ color: '#8a99a8', fontSize: '0.92rem', lineHeight: 1.7, maxWidth: '280px' }}>
              The premium recruitment ecosystem for Corporate Finance, PE and Investment Banking.
            </Box>
          </Box>

          <Box>
            <Box style={{ color: 'white', fontWeight: 600, fontSize: '1rem', marginBottom: '24px' }}>About us</Box>
            <FooterLink href="https://sainoo.sainoo.com/">Who are we</FooterLink>
            <FooterLink href="/explore">Discover the right company</FooterLink>
            <FooterLink href="/resources">Online resources</FooterLink>
            <FooterLink href="/jobs">Jobs</FooterLink>
            <FooterLink href="/features">AI and Machine learning</FooterLink>
            <FooterLink href="/features#ATS">Applicant tracking system</FooterLink>
          </Box>

          <Box>
            <Box style={{ color: 'white', fontWeight: 600, fontSize: '1rem', marginBottom: '24px' }}>Meet with us</Box>
            <FooterLink href="/auth/sign_up/company">Recruiters</FooterLink>
            <FooterLink href="/auth/sign_up">Candidates</FooterLink>
            <FooterLink href="mailto:contact@sainoo.com">Press</FooterLink>
            <FooterLink href="https://sainoo.sainoo.com/careers">Careers</FooterLink>
            <FooterLink href="https://blog.sainoo.com" target="_blank" rel="noopener noreferrer">
              Sainoo magazine
            </FooterLink>
          </Box>

          <Box>
            <Box style={{ color: 'white', fontWeight: 600, fontSize: '1rem', marginBottom: '24px' }}>We are social</Box>
            <Flex style={{ gap: '16px' }}>
              <FooterLink href="https://www.facebook.com/sainoofficial" style={{ margin: 0 }}>
                Facebook
              </FooterLink>
              <FooterLink href="https://www.linkedin.com/company/sainoo" style={{ margin: 0 }}>
                LinkedIn
              </FooterLink>
            </Flex>
          </Box>
        </Box>

        <Flex
          style={{
            borderTop: '1px solid rgba(255,255,255,0.05)',
            paddingTop: '40px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '20px'
          }}
        >
          <Box style={{ color: '#5A6A7A', fontSize: '0.8rem' }}>
            © {new Date().getFullYear()} Sainoo. All rights reserved.
          </Box>
          <Flex style={{ gap: '24px', display: 'flex' }}>
            <FooterLink href="https://www.linkedin.com/company/sainoo" style={{ margin: 0 }}>
              LinkedIn
            </FooterLink>
            <FooterLink href="https://twitter.com" style={{ margin: 0 }}>
              Twitter
            </FooterLink>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default EmployerFooter;
